import { Button } from "@dropbox/dig-components/buttons";
import { Text, Title } from "@dropbox/dig-components/typography";
import { Box, useTheme } from "@dropbox/dig-foundations";
import { UIIcon } from "@dropbox/dig-icons";
import {
  AddLine,
  CustomizeLine,
  ShareLine,
  StacksLine,
} from "@dropbox/dig-icons/assets";

import { Trans } from "@mirage/translations";

const IMAGE =
  "https://assets.dropbox.com/images/dashweb/emptystates/v3/share_stacks.png";
const DARK_IMAGE =
  "https://assets.dropbox.com/images/dashweb/emptystates/v3/share_stacks_dark.png";

function BodyRow({
  message,
  icon,
}: {
  message:
    | "stacks_empty_state_embed_group_related_files"
    | "stacks_empty_state_embed_personalize_the_branding"
    | "stacks_empty_state_embed_share_with_anyone";
  icon: (props: React.SVGProps<SVGSVGElement>) => React.ReactElement;
}) {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      columnGap="Micro Medium"
    >
      <Box width="fit-content">
        <UIIcon src={icon} size="large" />
      </Box>
      <Text>
        <Trans i18nKey={message} components={{ bold: <b /> }} />
      </Text>
    </Box>
  );
}

export function AllStacksEmbedEmptyState() {
  const { mode } = useTheme();
  const isDarkMode = mode === "dark";

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="row"
      alignItems="center"
      columnGap="Macro Medium"
      style={{ maxWidth: 900 }}
    >
      <Box style={{ maxWidth: 480 }}>
        <img
          src={isDarkMode ? DARK_IMAGE : IMAGE}
          alt=""
          style={{ maxWidth: "100%" }}
        />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        rowGap="Micro Large"
        minWidth="0"
      >
        <Title style={{ margin: 0 }}>
          <Trans i18nKey="stacks_empty_state_embed_title" />
        </Title>
        <Box display="flex" flexDirection="column" rowGap="Micro Large">
          <BodyRow
            message="stacks_empty_state_embed_group_related_files"
            icon={StacksLine}
          />
          <BodyRow
            message="stacks_empty_state_embed_personalize_the_branding"
            icon={CustomizeLine}
          />
          <BodyRow
            message="stacks_empty_state_embed_share_with_anyone"
            icon={ShareLine}
          />
        </Box>
        <Box>
          <Button
            variant="primary"
            size="large"
            onClick={() => {}}
            withIconStart={<UIIcon src={AddLine} />}
          >
            <Trans i18nKey="stacks_empty_state_embed_button" />
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
